/**
 * Where the overlay seams' surfaces sit, stated once for all of them.
 *
 * ---------------------------------------------------------------------------
 * The panel class string shared by `DialogContent` and `AlertDialogContent`.
 *
 * The two are character-for-character the same, and deliberately so: the
 * max-height plus `overflow-y-auto` half of it is one decision, taken once for
 * both — a centred `fixed` panel taller than the viewport is unreachable where
 * antd's top-anchored one scrolls the page. Keeping one constant is what stops
 * the two drifting apart the next time either is touched.
 */
export const OVERLAY_PANEL_CLASS =
  'bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-[1000] flex max-h-[calc(100vh-4rem)] w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] flex-col overflow-y-auto rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg'

/**
 * The stacking level for a POPUP surface — the Select dropdown and the
 * Dropdown menu.
 *
 * 1050 is not a taste choice: it is what antd puts these two at. antd's
 * `zIndexPopupBase` is 1000 and `consumerBaseZIndexOffset` adds 50 for
 * `SelectLike` and `Dropdown` (`antd/es/_util/hooks/useZIndex.js`), so both
 * components' generated CSS carries `z-index: 1050`. Matching it is what keeps
 * a popup correct on a MIXED screen: with the toggle on, an un-ported antd
 * surface — a DatePicker panel, a Cascader, antd's own Table page-size
 * changer — is on the page at the same time and was laid out against those
 * numbers.
 *
 * The rest of the scale, for the reader who has to place a future seam:
 * `OVERLAY_PANEL_CLASS` above holds `z-[1000]` (antd's Modal/Drawer base) and
 * `src/components/ui/tooltip.tsx` holds `z-[1070]` (antd's tooltip token). So
 * a Select opened inside a Modal is above its panel, and a Tooltip raised from
 * a Dropdown item is above the menu — in either design mode.
 */
export const OVERLAY_POPUP_Z_CLASS = 'z-[1050]'
